import { useContext, useMemo } from 'react';

import { AppContext } from '../context/app';
import type { NavStep } from '../context/types';
import { useNetworkManager } from './useNetworkManager';

export const useFormattedWalkingInstruction = (
  step: NavStep,
  nextStep?: NavStep,
): string => {
  const { landmarksData } = useNetworkManager();
  const { navDestinationPlace } = useContext(AppContext);

  const nextLandmark: string | undefined = useMemo(() => {
    // Find the endpoint of this step (aka the starting point of the next step)
    if (nextStep) {
      // filter by building
      const landmarksFilteredByBuilding = landmarksData?.filter(
        (landmark) => landmark.location.building === nextStep.polyLine[0].b,
      );
      // filter by floor
      const landmarksFilteredByFloor = landmarksFilteredByBuilding?.filter(
        (landmark) => landmark.location.floor === nextStep.polyLine[0].f,
      );
      // find by id
      const foundLandmark = landmarksFilteredByFloor?.find(
        (landMark) => landMark.location.id === nextStep.polyLine[0].k,
      );
      return foundLandmark?.short_name || foundLandmark?.name;
    }
    // Or, this step is the last step
    return navDestinationPlace?.name || '';
  }, [landmarksData, navDestinationPlace, nextStep]);

  return useMemo(() => {
    const indexOfOpeningBracket = step.instruction.indexOf('${');
    const indexOfClosingBracket = step.instruction.indexOf('}');
    if (
      indexOfOpeningBracket !== -1 &&
      indexOfClosingBracket !== -1 &&
      nextLandmark
    ) {
      const inlineVariable = step.instruction.substring(
        indexOfOpeningBracket,
        indexOfClosingBracket + 1,
      );
      return step.instruction.replace(inlineVariable, nextLandmark);
    }
    return step.instruction;
  }, [nextLandmark, step.instruction]);
};
